import { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-[#363a73] fixed w-full z-50">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <span className="text-2xl font-bold text-white">LR POWER SYSTEMS</span>
            </Link>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-white hover:text-white/80 px-3 py-2 text-sm font-medium">
              HOME
            </Link>
            <Link to="/about" className="text-white hover:text-white/80 px-3 py-2 text-sm font-medium">
              ABOUT US
            </Link>
            <Link to="/services" className="text-white hover:text-white/80 px-3 py-2 text-sm font-medium">
              SERVICES
            </Link>
            <Link to="/projects" className="text-white hover:text-white/80 px-3 py-2 text-sm font-medium">
              PROJECTS
            </Link>
            <Link to="/gallery" className="text-white hover:text-white/80 px-3 py-2 text-sm font-medium">
              GALLERY
            </Link>
            <Link to="/contact" className="text-white hover:text-white/80 px-3 py-2 text-sm font-medium">
              CONTACT US
            </Link>
            <button 
              onClick={() => window.location.href = 'https://wa.me/91779977771'}
              className="bg-[#ff7f50] text-white px-6 py-2 rounded text-sm font-medium hover:bg-[#ff6b3d] transition-colors"
            >
              GET A QUOTE
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white/80 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#1a237e]">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link to="/" className="block text-white hover:text-white/80 px-3 py-2 rounded-md text-base font-medium">
              HOME
            </Link>
            <Link to="/about" className="block text-white hover:text-white/80 px-3 py-2 rounded-md text-base font-medium">
              ABOUT US
            </Link>
            <Link to="/services" className="block text-white hover:text-white/80 px-3 py-2 rounded-md text-base font-medium">
              SERVICES
            </Link>
            <Link to="/projects" className="block text-white hover:text-white/80 px-3 py-2 rounded-md text-base font-medium">
              PROJECTS
            </Link>
            <Link to="/gallery" className="block text-white hover:text-white/80 px-3 py-2 rounded-md text-base font-medium">
              GALLERY
            </Link>
            <Link to="/contact" className="block text-white hover:text-white/80 px-3 py-2 rounded-md text-base font-medium">
              CONTACT US
            </Link>
            <Link 
              to="/quote" 
              className="block bg-[#ff7f50] text-white px-4 py-2 rounded text-base font-medium hover:bg-[#ff6b3d] transition-colors"
            >
              GET A QUOTE
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 